import React, { useEffect, useState, useRef } from 'react';
import { base_url } from '../../Api/Api';
import { Loader } from '../../Global/Loader';

import Header from '../../Global/Header';
import ItemLicense from './itemLicenses';

const MyLicenses = (props) => {

    const [state, setState] = useState({
        licenses: [],
        loader: true,
        animToggle: false
    })

    useEffect(() => {


        base_url.get(`my_licenses`)
            .then(response => {
                console.log(response.data, 'my_licenses')
                setState({
                    ...state,
                    licenses: response.data,
                    loader: false,
                    animToggle: true
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg main-courses main-license ${state.animToggle ? 'active' : ''}`}>
                <Header
                    innerPage={true}
                    title={'گواهینامه های من'} />

                <div className="body-courses">

                    {state.licenses.length == 0 ?
                        <span className="no-info"> <i className="icon-certificate"></i> گواهینامه ای برای نمایش وجود ندارد. </span>
                        :
                        state.licenses.map(item =>
                            <ItemLicense
                                key={item.id}
                                data={item} />
                        )
                    }

                </div>

            </div>
        </React.Fragment>
    );
}

export default MyLicenses;